"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importDefault(require("react"));
const LowLatencyToggle_1 = tslib_1.__importDefault(require("./LowLatencyToggle"));
const QualitySelect_1 = tslib_1.__importDefault(require("./QualitySelect"));
const Tooltip_1 = tslib_1.__importDefault(require("../../../../ui-lib/Tooltip/Tooltip"));
const ModularQualitySettings = (0, mobx_react_lite_1.observer)(({ classes = {}, disableToggle, disableSelect, showBitrate, active, ...props }) => {
    return (react_1.default.createElement(Tooltip_1.default, { active: active },
        react_1.default.createElement(QualitySelect_1.default, { disableSelect: disableSelect, showBitrate: showBitrate }),
        react_1.default.createElement(LowLatencyToggle_1.default, { disabledOff: disableToggle })));
});
/**
 * @deprecated
 * use components directly (Tooltip, QualitySelect, LowLatencyToggle)
 */
exports.default = ModularQualitySettings;
//# sourceMappingURL=QualitySettings.js.map